import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import ServiceCard, { ServiceCardStyles } from "../components/ServiceCard";
import ServicesSidebar from "../components/ServicesSidebar";
import { SERVICES } from "../data/services";
import { api } from "../lib/api";
import { useI18n } from "../i18n";

export default function Services() {
  const { t, pick } = useI18n();
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data?.data || null)).catch(() => {});
    api.post("/track/visit", { path: "/servicios" }).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen text-white" data-testid="services-page">
      <NavBar />
      <section className="relative overflow-hidden pt-32 sm:pt-36 md:pt-40 pb-8 md:pb-12 bg-[#06080D]">
        <div className="absolute top-1/3 -left-40 w-[480px] h-[480px] rounded-full bg-cyan-500/10 blur-[140px] pointer-events-none" />
        <div className="absolute bottom-0 -right-40 w-[480px] h-[480px] rounded-full bg-emerald-400/5 blur-[140px] pointer-events-none" />
        <div className="absolute inset-0 grid-bg opacity-10 pointer-events-none" />

        <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-10 text-center">
          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .7, delay: .1 }}
            className="font-display text-[2.25rem] leading-[1.05] sm:text-5xl lg:text-6xl tracking-tight max-w-3xl mx-auto">
            <span className="chrome-text">{pick("Servicios", "Services", "Serviços")}</span>
          </motion.h1>
        </div>
      </section>

      <section className="relative pb-16 sm:pb-20 md:pb-24 bg-[#06080D]" data-testid="services-grid-section">
        <ServiceCardStyles />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-[290px_minmax(0,1fr)] gap-6 lg:gap-8">
            {/* SIDEBAR (izquierda) */}
            <ServicesSidebar whatsapp={content?.contact?.whatsapp} />

            {/* GRID de tarjetas (derecha) */}
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
              {SERVICES.map((s, i) => (
                <motion.div
                  key={s.slug}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
                >
                  <ServiceCard service={s} index={i} />
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer content={content} />
      <FloatingWhatsApp phone={content?.contact?.whatsapp} />
    </div>
  );
}
